import Vue from 'vue'
import { liveStatsVuexMutations, liveStatsDefaultState } from '@ahaslides-product/frontend-toolkit'
import actions from './live-stats.actions'
import getters from './live-stats.getters'

export default {
  namespaced: true,
  state: liveStatsDefaultState,
  mutations: liveStatsVuexMutations(Vue),
  actions,
  getters,
}
